import React from 'react';
import { FiCheck, FiClock } from 'react-icons/fi';
import { formatDistanceToNow } from 'date-fns';

function EODReportCard({ report, canViewAllReports }) {
  return (
    <div className="report-card">
      <div className="report-header">
        <div className="report-user">
          <div className="user-avatar-small">
            {report.user?.firstName?.[0]}{report.user?.lastName?.[0]}
          </div>
          <div>
            <div className="user-name">
              {report.user?.firstName} {report.user?.lastName}
              {report.user?.role === 'company_manager' && (
                <span className="role-tag company-manager">Company Manager</span>
              )}
            </div>
            <div className="report-date">
              {new Date(report.date).toLocaleDateString()} • {formatDistanceToNow(new Date(report.createdAt), { addSuffix: true })}
            </div>
          </div>
        </div>
        <span className={`report-status ${report.status}`}>
          {report.status === 'submitted' && <FiClock />}
          {report.status === 'approved' && <FiCheck />}
          {report.status}
        </span>
      </div>

      <div className="report-content">
        {report.tasksCompleted?.length > 0 && (
          <div className="report-section">
            <h4>✅ Tasks Completed</h4>
            <ul>
              {report.tasksCompleted.map((task, idx) => (
                <li key={idx}>{task}</li>
              ))}
            </ul>
          </div>
        )}

        {report.tasksInProgress?.length > 0 && (
          <div className="report-section">
            <h4>🔄 Tasks In Progress</h4>
            <ul>
              {report.tasksInProgress.map((task, idx) => (
                <li key={idx}>{task}</li>
              ))}
            </ul>
          </div>
        )}

        {report.blockers?.length > 0 && (
          <div className="report-section">
            <h4>🚧 Blockers</h4>
            <ul>
              {report.blockers.map((blocker, idx) => (
                <li key={idx}>{blocker}</li>
              ))}
            </ul>
          </div>
        )}

        {report.content && (
          <div className="report-section">
            <h4>📝 Additional Notes</h4>
            <p>{report.content}</p>
          </div>
        )}

        {report.hoursWorked > 0 && (
          <div className="report-hours">
            ⏰ Hours Worked: <strong>{report.hoursWorked}</strong>
          </div>
        )}
      </div>

      {/* Show visibility notice for Company Manager reports */}
      {report.user?.role === 'company_manager' && !canViewAllReports && (
        <div className="restricted-notice">
          <p>This report is restricted and can only be viewed by CEO and Co-CEO</p>
        </div>
      )}
    </div>
  );
}

export default React.memo(EODReportCard);
